// extracted by mini-css-extract-plugin
export default {"wrapper":"Tokenomics_wrapper__A-r8-","bottom":"Tokenomics_bottom__EUP8q","title":"Tokenomics_title__K2Q5I","cards":"Tokenomics_cards__hscy1","img":"Tokenomics_img__8sxLX"};